import { Center, Loader, Stack } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useNavigate, useParams, useSearchParams } from 'react-router'
import { useGetCameraDetails } from '@/queries/cameraQueries'
import { ErrorWithReload } from '../../ui-shared/ErrorWithReload/ErrorWithReload'
import { ListItemDrawer } from '../../ui-shared/ListItemDrawer/ListItemDrawer'
import { CameraImage } from './CameraImage'
import { CameraInfo } from './CameraInfo'
import { useCameraRefresh } from './useCameraRefresh'

const CAMERA_DEVICE_ID_PARAM = 'cameraDeviceId'

export const CameraDetails = () => {
  const navigate = useNavigate()
  const { cameraId } = useParams()
  const [currentSearchParams] = useSearchParams()

  const deviceId = currentSearchParams.get(CAMERA_DEVICE_ID_PARAM) || undefined
  const isOpened = !!cameraId && !!deviceId

  const {
    data: camera,
    isLoading,
    isError,
    refetch
  } = useGetCameraDetails({
    deviceId: deviceId || '',
    cameraId: cameraId || '',
    enabled: isOpened
  })

  const { isRefreshing, refreshCameraImage } = useCameraRefresh({
    deviceId,
    cameraId,
    onRefresh: () => void refetch()
  })

  const handleClose = () => {
    void navigate(-1)
  }

  return (
    <ListItemDrawer
      opened={isOpened}
      title={camera?.camera_name}
      onClose={handleClose}
    >
      {isLoading && (
        <Center h={120}>
          <Loader size="md" />
        </Center>
      )}

      {isError && !isLoading && (
        <ErrorWithReload onReload={() => void refetch()}>
          <FormattedMessage id="cameras.data.error" />
        </ErrorWithReload>
      )}

      {camera && (
        <Stack maw={1100}>
          <CameraImage
            imageUrl={camera.image}
            isRefreshing={isRefreshing}
            onRefresh={() => void refreshCameraImage()}
          />
          <CameraInfo camera={camera} />
        </Stack>
      )}
    </ListItemDrawer>
  )
}
